import { render, staticRenderFns } from "./LoadFiles.vue?vue&type=template&id=25ada51f&"
import script from "./LoadFiles.vue?vue&type=script&lang=js&"
export * from "./LoadFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ada51f')) {
      api.createRecord('25ada51f', component.options)
    } else {
      api.reload('25ada51f', component.options)
    }
    module.hot.accept("./LoadFiles.vue?vue&type=template&id=25ada51f&", function () {
      api.rerender('25ada51f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/LoadFiles.vue"
export default component.exports